import React from 'react';

import { Helpers } from '../../core/src/helpers';
import ProductMap from '../../product/components/product-map';
import ProductCard from '../../product/components/product-card';
import ProductShowPlaceholder from '../../product/components//product-show-placeholder';
import ProductFilter from '../../product/components//product-filter';
import ProductResults from '../../product/components/product-results';
import SearchResults from '../../search-filter/components/search-results';
import SearchTopBar from '../../search-filter/components/search-top-bar';
import VWAFilterCount from '../../vwa/components-v2/vwa-filter-count';
import { withProductContainer } from '../../product/components/product-container';
import Dropdown from '../../ui/components/dropdown';
//TODO: move this import if v2 is winner
import { getProdHideStatus, SORT_TYPES } from '../../product/components/product-list'
import CompareDrawer from '../../compare/components/compare-drawer';
import SaleMobileFilter from './sale-mobile-filter';

const { memoize } = Helpers;

class ProductList extends React.PureComponent {
    static whyDidYouRender = true;

    constructor(props) {
        super(props);
        this.changeSort = this.changeSort.bind(this);
        this.tabStyle = {};
        this.productItem = this.productItem.bind(this);
        this.prefetchInterval = null;
    }

    componentDidMount() {
        const { pg, productCat = {}, fetchProducts, prefetchTabs } = this.props;
        if (!productCat.products || productCat.products.length === 0) {
            fetchProducts(pg);
        } else if (prefetchTabs) {
            this.prefetchProduct();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.slug == this.props.slug && this.props.pg && prevProps.pg !== this.props.pg && !this.props.productCat.products.length) {
            prevProps.fetchProducts(this.props.pg);
        } else if (this.props.prefetchTabs) {
            this.prefetchProduct();
        }
    }

    componentWillUnmount() {
        clearTimeout(this.prefetchInterval);
    }

    prefetchProduct = () => {
        const { pg, prefetchProducts } = this.props;
        const [vanityUrl] = pg.split(':')
        //if there are still keys left to fetch, prefetch them
        if (prefetchProducts) {
            this.prefetchInterval = setTimeout(() => prefetchProducts(vanityUrl), 400);
        }
    }

    changeSort(value) {
        this.props.sortProducts(value, this.props.pg);
        this.props.scrollTop();
    }

    productItem(product, key, enableAppPDP, className, productIndex, placeholder) {
        const {
            addToCart = () => { },
            slugKey,
            pg
        } = this.props;

        const jumpInfo = {
            slugKey,
            pg: pg.split(":").pop()
        }

        //pass in placehodler that has price component so that prices are available earlier and can filter OOS/NO IR
        if (placeholder) {
            return <ProductShowPlaceholder product={product} />
        }

        return (
            <ProductCard
                className={className}
                key={key}
                product={product}
                addToCart={addToCart}
                fetchSpecs={this.fetchTechSpecs}
                jumpInfo={jumpInfo}
                enableAppPDP={enableAppPDP}
                productIndex={productIndex}
            />
        );
    }

    prdFilterCondition = memoize((searchResults, query) => (prd, params) => {
        let { prdClass } = prd;
        const { autoHideType, disableAutoHide } = this.props;
        //if filters are enabled ,ignore auto hide functionality
        if (searchResults && searchResults.length > 0) {
            //only show UDF when search is enabled if not filtering on anything
            if (prdClass === "USER_DEFINED") {
                return Object.keys(query || {}).length === 0;
            }
            return searchResults.indexOf(prd.sku) > -1;
        }
        return getProdHideStatus(autoHideType, disableAutoHide, prd, params);
    })

    render() {
        const {
            fixedHeader,
            productCat,
            enableAppPDP,
        } = this.props;
        const { products } = productCat
        const shiftProductsClassName = fixedHeader ? " shift-down" : "";

        return (
            <> 
                <SaleMobileFilter setSort={this.changeSort} sortOptions={SORT_TYPES} sortValue={productCat.sortValue}/>
                <SearchResults>
                    {({ results, disableSearch, query, searchInProgress }) => (
                        <ProductFilter products={products} condition={this.prdFilterCondition(!disableSearch && !searchInProgress ? results : null, query)}>
                            {(filteredProducts) => {
                                const productListLength = filteredProducts.filter(p => p.prdClass !== 'USER_DEFINED').length;
                                return (
                                    <>
                                        <ProductResults>
                                            <SearchTopBar className={'v2'}>
                                                <VWAFilterCount count={productListLength} />
                                                <Dropdown
                                                    label={'Sort by'}
                                                    className="search-sort"
                                                    options={SORT_TYPES}
                                                    value={productCat.sortValue}
                                                    onChange={this.changeSort}
                                                />
                                                <span className="search-hits v2">
                                                    {productListLength > 0 && (
                                                        <React.Fragment>
                                                            <span className="count">{productListLength}</span> results
                                                        </React.Fragment>
                                                    )}
                                                </span>
                                            </SearchTopBar>
                                            <div className={'products-list' + shiftProductsClassName}>
                                                <ProductMap
                                                    products={filteredProducts}
                                                    productItem={this.productItem}
                                                    enableAppPDP={enableAppPDP}
                                                    customPlaceHolder={true}
                                                    productItemClassName={'product-card-new'}
                                                    v2
                                                />
                                            </div>
                                        </ProductResults>
                                    </>
                                );
                            }
                            }
                        </ProductFilter>
                    )}
                </SearchResults>
                <CompareDrawer />
            </>
        );
    }
}

ProductList.defaultProps = {
    productCat: { products: [], sortValue: 'rank.recommended' },
    filtersResults: { hits: { hits: null } },
    userInfo: {}
};


export default withProductContainer(ProductList)